module.exports = __webpack_public_path__ + "media/images/cropper-green-ddf1b165e2982736fb6648aaee4d279c.png";